export default [
  {
    title: 'Maintanance',
    subtitle: 'Monthly web updates for http://www.themeforest.net',
    price: 250.0,
    quantity: 1
  },
  {
    title: 'Recurring Bill (Hosting)',
    subtitle: 'Monthly dedicated VPN web hosting (1 Jan - 30 Jan, 2014)',
    price: 652.87,
    quantity: 3
  },
  {
    title: 'Recurring Bill (Domain)',
    subtitle: '2 year domain name purchase',
    price: 239.0,
    quantity: 3
  },
  {
    title: 'Web design',
    subtitle: 'PSD to HTML Conversion (3 pages)',
    price: 958.0,
    quantity: 1
  }
];
